const PARENT_ORIGIN_KEY = 'parent_origin';

export function getParentOrigin() {
  const fromStorage = sessionStorage.getItem(PARENT_ORIGIN_KEY);
  if (fromStorage) return fromStorage;

  const fromQuery = new URLSearchParams(location.search).get(PARENT_ORIGIN_KEY);
  if (fromQuery) {
    sessionStorage.setItem(PARENT_ORIGIN_KEY, fromQuery);
    return fromQuery;
  }

  if (window.self !== window.top) {
    const referrer = document.referrer?.trim();
    if (referrer && !referrer.includes('app.uzhnet.com')) {
      sessionStorage.setItem(PARENT_ORIGIN_KEY, referrer);
      return referrer;
    }
  }

  return null;
}
